type RuntimeConfigValue = string | undefined;

declare global {
  interface Window {
    __APP_CONFIG__?: Record<string, string | undefined>;
  }
}

const runtimeConfig =
  typeof window !== 'undefined' && window.__APP_CONFIG__ ? window.__APP_CONFIG__ : {};

const viteConfig = import.meta.env as Record<string, string | boolean | undefined>;

const getConfigValue = (key: string, fallback?: string): RuntimeConfigValue => {
  const runtimeValue = runtimeConfig[key];

  //returns runtime value when in deployed environment from window.__APP_CONFIG__
  if (runtimeValue !== undefined && runtimeValue !== '') {
    return runtimeValue;
  }

  const viteValue = viteConfig[key];

  //returns vite value when in development environment from import.meta.env
  if (typeof viteValue === 'string' && viteValue !== '') {
    return viteValue;
  }

  return fallback;
};

export const getRuntimeConfig = (key: string, fallback?: string): string =>
  getConfigValue(key, fallback) ?? '';

export const getRuntimeNumberConfig = (key: string, fallback: number): number => {
  const value = Number(getRuntimeConfig(key, String(fallback)));

  return Number.isFinite(value) ? value : fallback;
};

export const getRuntimeBooleanConfig = (key: string, fallback: boolean): boolean => {
  return getRuntimeConfig(key, String(fallback)) === 'true';
};
